var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('avatar-widget',{attrs:{"avatar-src":_vm.currentOrg ? _vm.currentOrg.avatar : null,"placeholder":_vm.$vuetify.icons.values.organization,"onUpdate":_vm.onNewAvatar,"logo":""}})}
var staticRenderFns = []

export { render, staticRenderFns }